import LabReports from "@/components/LabReports";
import CardListContext from "@/contexts/CardListContext";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import useCardList from "@/hooks/useCardList";
import ChartModal from "@/tpo/ChartModal";
import Stack from "@/tpo/Stack";

import GenesBiomarkers from "../../GeneBiomarkers";
import ModelContent from "./ModelContent";
import RelatedReportsSection from "./RelatedReportsSection";
import ReleaseResultsToClient from "./ReleaseResultsToClient";
import { GENES_TEST_BIOMARKERS_CONNECTION_QUERY, LAB_REPORTS_QUERY } from "./graphql";

export default function GenesTestContent({ userTest, clientId }) {
  const { cardOpen, closeCard, viewCard, setCardOpen } = useCardList();

  const { organisation } = useOrganisationContext();

  return (
    <Stack gap={[20, 20, 40]}>
      <RelatedReportsSection userTest={userTest} />
      <ReleaseResultsToClient userTest={userTest} />
      <LabReports
        query={LAB_REPORTS_QUERY}
        userTest={userTest}
        userId={clientId}
        variables={{
          userId: clientId,
          organisationId: organisation?.id,
          forPractitioner: true
        }}
        organisationId={organisation?.id}
      />
      <CardListContext.Provider
        value={{
          cardOpen,
          closeCard,
          viewCard,
          setCardOpen
        }}
      >
        <GenesBiomarkers
          userTest={userTest}
          query={GENES_TEST_BIOMARKERS_CONNECTION_QUERY}
          skip={!organisation?.id}
        />
      </CardListContext.Provider>
      <ChartModal close={() => setCardOpen(undefined)} show={!!cardOpen?.type}>
        <ModelContent
          type={cardOpen?.type}
          item={cardOpen?.item}
          isGenesTest={userTest.isGenesTest}
        />
      </ChartModal>
    </Stack>
  );
}
